import {
  makeObservable, observable, flow, action,
} from 'mobx';
import { toast } from 'sonner';

import { api } from '@/lib/services';
import { ApiRoutes } from '@/lib/routes';

export default class DocumentScanSchedulerActivityStore {
  loading = false;

  loaded = false;

  triggering = false;

  schedulerId = null;

  status = null;

  lastUpdateAt = null;

  recentLogs = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      loaded: observable,
      triggering: observable,
      schedulerId: observable,
      status: observable,
      lastUpdateAt: observable,
      recentLogs: observable,
      reset: action,
      load: flow,
      triggerSweep: flow,
    });

    this.parentStore = parentStore;
  }

  reset() {
    this.schedulerId = null;
    this.status = null;
    this.lastUpdateAt = null;
    this.recentLogs = [];
    this.loaded = false;
  }

  * load() {
    try {
      this.loading = true;
      const response = yield api.get(ApiRoutes.forDocumentScanSchedulerActivity());
      const data = response.data ?? {};
      this.schedulerId = data.schedulerId ?? null;
      this.status = data.status ?? null;
      this.lastUpdateAt = data.lastUpdateAt ?? null;
      this.recentLogs = data.recentLogs ?? [];
      this.loaded = true;
      return { success: true };
    } catch (e) {
      toast.error('Could not load document scan scheduler activity', {
        description: e?.response?.data?.message || 'Unexpected error.',
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }

  * triggerSweep() {
    try {
      this.triggering = true;
      yield api.post(ApiRoutes.forDocumentScanSchedulerSweepNow());
      toast.success('Document scan sweep queued');
      yield this.load();
      return { success: true };
    } catch (e) {
      toast.error('Could not trigger document scan sweep', {
        description: e?.response?.data?.message || 'Unexpected error.',
      });
      return { success: false, error: e };
    } finally {
      this.triggering = false;
    }
  }
}
